const DatabaseTypes = [
  { key: 'MY', label: 'MySQL' },
  { key: 'MS', label: 'MsSQL' },
  /*
  // Disabled CB & ES as currently they are not supported
  { key: 'CB', label: 'Couchbase' },
  { key: 'ES', label: 'Elasticsearch' },
  */
  { key: 'OR', label: 'Oracle' },
  { key: 'PG', label: 'PostgreSQL' },
  { key: 'CA', label: 'Cassandra' },
  { key: 'CB', label: 'Couchbase' },
  { key: 'MG', label: 'MongoDB' },
];

export default DatabaseTypes;
